import * as React from 'react';
import './styles.scss';
import classNames from 'classnames';
import {PropsWithChildren} from "react";

export interface IRadioListProps extends PropsWithChildren {
    /** className to append */
    className?: string;
}

const RadioList: React.FunctionComponent<IRadioListProps> = (props) => {
    return (
        <ul
            role="radiogroup"
            className={classNames('radio-list', props.className)}
        >
            {React.Children.map(props.children, (child: any, i) => {
                return (<li key={i}>{child}</li>);
            })}
        </ul>
    );
};

RadioList.displayName = 'RadioList';

export default RadioList;
